import { render, staticRenderFns } from "./TermsOfUseChile.vue?vue&type=template&id=b2d2ec3a&scoped=true"
import script from "./TermsOfUseChile.vue?vue&type=script&lang=js"
export * from "./TermsOfUseChile.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseChile.vue?vue&type=style&index=0&id=b2d2ec3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d2ec3a",
  null
  
)

export default component.exports